import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { em } from '@/utils/helpers';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      width: '100%',

      '& p, h1, h2, h3, h4, h5, h6': {
        marginTop: 0,
      },
    },
    cta: {
      [muiTheme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    gridIcon: {
      display: 'flex',
      marginRight: '25px !important',
      width: '32px',
      height: '32px',
      flexShrink: 0,
      '& picture': {
        width: '100%',
      },
    },
    gridItem: {
      alignItems: 'flex-start',
      display: 'flex',
      flexBasis: '45%',

      [muiTheme.breakpoints.down('sm')]: {
        flexBasis: '100%',
        marginBottom: '24px',
      },

      '&:nth-of-type(odd)': {
        marginRight: '10%',
        [muiTheme.breakpoints.down('sm')]: {
          marginRight: '0',
        },
      },
    },
    gridMultiRow: {
      '& $gridItem:first-of-type, $gridItem:nth-of-type(2)': {
        marginBottom: '80px',

        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: '24px',
        },
      },
    },
    gridText: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: 'calc(100% - 59px)',

      '& h1, h2, h3, h4, h5, h6': {
        ...typography.h6,

        '&:not(:last-child)': {
          marginBottom: em({ size: 8, base: 12 }),
        },
      },
    },
    iconTextGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: 0,
      paddingInlineStart: 0,
    },
    leftGroup: {
      paddingRight: '42px',
    },
    leftGroupDescription: {
      '& h1, h2, h3, h4, h5, h6': {
        ...typography.h2,
        marginBottom: '24px',
      },
    },
    leftGroupLogo: {
      marginBottom: '24px',
    },
  }),
  { name: 'GenIconTextGrid' },
);

export default useStyles;
